// google-analytics.service.ts
import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable()
export class GoogleAnalyticsService {

  constructor() {}

  sendPageView(url: string) {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'page_view', {
        page_path: url
      });
    }
  }

  sendEvent(eventName: string, params: { [key: string]: any } = {}) {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, params);
    }
  }

  setUserProperty(property: string, value: any) {
    if (typeof gtag !== 'undefined') {
      gtag('set', { [property]: value });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/services/google-analytics.service.ts